import pfsettings from './PfSettings.js';
import incometax from './incometax.js';
import gratuity from './gratuity.js';
import formsixteen from './formsixteen.js';
import formtwentyfour from './formtwentyfour.js';
export default {
    namespaced: true,
    modules: {
        pfsettings: pfsettings,
        incometax: incometax,
        gratuity: gratuity,
        formsixteen: formsixteen,
        formtwentyfour: formtwentyfour
    }
}